import React from "react";
import { Link } from "react-router-dom";
import {
    EnvironmentOutlined,
    MailOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import logo from "../assets/logo.svg";
import footerTitle from "../assets/footerTitle.svg";
import fb from "../assets/fb.svg";
import instagram from "../assets/instagram.svg";
import lin from "../assets/lin.svg";
import youtube from "../assets/youtube1.svg";
import twitter from "../assets/twitter1.svg";
import { solutionNavItems } from "../data/navigation";
import "../styles/footer.css";

const softwareLinks = [
    { label: "EasyOn", path: "/software/easyon" },
    { label: "HonestiIQ", path: "/software/honesti-crm" },
    { label: "WhatsApp Bulk Sender", path: "/software/whatsapp-bulk-sender" },
    { label: "Social Media Automation", path: "/software/socialmedia-automation-software" },
    { label: "WhatsApp API Platform", path: "/software/whatsapp-api-platform" },
    { label: "SMS, Call & Email Broadcast", path: "/software/sms-call-email-broadcast" },
];

const companyLinks = [
    { label: "Home", path: "/" },
    { label: "Know Us", path: "/know-us" },
    { label: "Contact", path: "/contact" },
];

const socialLinks = [
    {
        label: "Facebook",
        href: "https://www.facebook.com/profile.php?id=61561747533515",
        icon: fb,
        size: 30,
    },
    {
        label: "Instagram",
        href: "https://www.instagram.com/honesti__digital/",
        icon: instagram,
        size: 30,
    },
    {
        label: "LinkedIn",
        href: "https://www.linkedin.com/in/Honesti-digital",
        icon: lin,
        size: 30,
    },
    {
        label: "YouTube",
        href: "https://www.youtube.com/channel/UCFrG43Yp-sG1NTTR9njsiDg",
        icon: youtube,
        size: 30,
    },
    {
        label: "X (Twitter)",
        href: "https://x.com/honestidigital",
        icon: twitter,
        size: 25,
    },
];

export const Footer = () => (
    <footer className="site-footer" id="contact-footer">
        <div className="site-footer__glow" aria-hidden="true" />

        <div className="site-footer__inner">
            <div className="site-footer__grid">
                <div className="site-footer__brand">
                    <Link to="/" className="site-footer__logo-link">
                        <img alt="Honesti Digital logo" className="site-footer__logo" src={logo} />
                        <img alt="Honesti Digital" className="site-footer__logo-title" src={footerTitle} />
                    </Link>
                    <p className="site-footer__tagline">
                        Premium digital solutions and automation software for businesses ready to grow.
                    </p>
                    <div className="site-footer__social">
                        {socialLinks.map((social) => (
                            <a
                                key={social.label}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="site-footer__social-link"
                                aria-label={social.label}
                            >
                                <img
                                    alt=""
                                    src={social.icon}
                                    style={{ height: social.size }}
                                    aria-hidden="true"
                                />
                            </a>
                        ))}
                    </div>
                </div>

                <nav className="site-footer__col" aria-label="Company">
                    <h3 className="site-footer__heading">Company</h3>
                    <ul className="site-footer__links">
                        {companyLinks.map((item) => (
                            <li key={item.path}>
                                <Link to={item.path}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav className="site-footer__col" aria-label="Solutions">
                    <h3 className="site-footer__heading">Solutions</h3>
                    <ul className="site-footer__links">
                        {solutionNavItems.map((item) => (
                            <li key={item.path}>
                                <Link to={item.path}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav className="site-footer__col" aria-label="Software">
                    <h3 className="site-footer__heading">Software</h3>
                    <ul className="site-footer__links">
                        {softwareLinks.map((item) => (
                            <li key={item.path}>
                                <Link to={item.path}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="site-footer__col site-footer__contact">
                    <h3 className="site-footer__heading">Contact</h3>
                    <ul className="site-footer__contact-list">
                        <li>
                            <PhoneOutlined className="site-footer__contact-icon" aria-hidden="true" />
                            <a href="tel:8838887194">+91 8838887194</a>
                        </li>
                        <li>
                            <MailOutlined className="site-footer__contact-icon" aria-hidden="true" />
                            <a href="mailto:support@honesti.in">support@honesti.in</a>
                        </li>
                        <li>
                            <EnvironmentOutlined className="site-footer__contact-icon" aria-hidden="true" />
                            <span>
                                No 26, Aadilakshmi Nagar, Lakshmipuram, Kolathur, Chennai- 99
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="site-footer__bottom">
                <p>© 2026, Honesti Digital. All Rights Reserved.</p>
            </div>
        </div>
    </footer>
);
